<template>
    <FileDropper></FileDropper>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const FileDropper = defineAsyncComponent(() =>
    import(
        "../../components/ProjectManagement/Ulta/FileDropper.vue"
        )
);

export default {
    name: "Ulta_FileDropper",
    components: { FileDropper, AuthLayout },
};
</script>
